import React, { useEffect, useState } from 'react'
import EstimateItem from './estimateItem'
import { fetchEstimates } from '../../../actions/estimatesActions'
import { connect, useSelector } from 'react-redux'
import withLocation from '../../withLocation'
import Carousel from 'react-multi-carousel'
import BannerMainImageSection from '../../bannerMainImageSection'
import Layout from '../../../layout'
import { Container, Modal } from 'react-bootstrap'
import { applicationRoles, httpVerbConstants } from 'constants/actionTypes'
import { fetchEstimates as consultantFetchEstimates } from '../../../actions/consultantEstimatesActions'
import { CheckBoxStyled } from 'components/styledComponents/checkBoxStyled/checkBoxStyled'
import { ReleaseCard } from '@mmsg/louie'
import ReleaseBanner from './releaseBanner'
import ReleasePopup from './releasePopup'
import { getCurrentResolutionBreakPoint } from 'utils/utilityFunctions'
import {
  EstimateItemWrapper,
  EstimateCompareIntro,
  EstimateComparePageStyled,
  ReleaseBannerMobileDiv,
  ReleaseBannerDesktopDiv,
} from './indexStyled'
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
  fireInteractionCustomEvent,
  checkConsultant,
} from '../../../helpers'
import { useTheme } from '@emotion/react'
import { ReactComponent as RightArrow } from '../../../icons/icon-right-arrow.svg'
import { ReactComponent as LeftArrow } from '../../../icons/icon-left-arrow.svg'
import * as E from './estimateItemStyled'
import useWindowSize from 'helpers/useWindowSize'
import useEleListHeight from 'helpers/useEleListHeight'
import { formatCurrency } from 'helpers'
import { remainingLeaseTime } from 'utils/utilityFunctions'
import Tooltip from '../../tooltip'
export const EstimatesScreen = ({
  accessToken,
  isAuthenticated,
  opportunityId,
  payFrequency,
  dispatch,
  applicationRole,
  estimatesExist,
}) => {
  let headers = { accessToken: accessToken }
  const userEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:estimates' },
      },
    })
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'compare estimates',
          label: 'compare estimates',
        },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:estimates' },
        },
      })
    }
  }
  const [isHidden, setIsHidden] = React.useState(true)
  const toggleHide = () => {
    updateCurrentLimit(isHidden)
    setIsHidden(!isHidden)
  }
  const consultantEvents = () => {
    fireViewStartCustomEvent({
      detail: {
        eventType: 'page load',
        page: { pageName: 'oly:mylease:consultant:estimates' },
      },
    })
    if (document.getElementById('page')) {
      fireViewEndCustomEvent('#page', {
        detail: {
          eventType: 'page load',
          page: { pageName: 'oly:mylease:consultant:estimates' },
        },
      })
    }
    fireInteractionCustomEvent({
      detail: {
        eventType: 'custom link click',
        data: {
          category: 'button',
          section: 'mylease',
          text: 'compare estimates',
          label: 'compare estimates',
        },
      },
    })
  }
  const customEvents = () => {
    checkConsultant() ? consultantEvents() : userEvents()
    toggleHide()
  }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      if (estimatesExist) {
        customEvents()
      } else {
        dispatch(
          checkConsultant()
            ? consultantFetchEstimates(
                opportunityId,
                headers,
                httpVerbConstants.HTTP_GET
              )
            : fetchEstimates(opportunityId)
        )
        customEvents()
      }
    }
  }, [])

  const headerHeight = useEleListHeight('.estimate-item__main--heading')
  const vehicleDescHeight = useEleListHeight('.estimate-item__description')
  const theme = useTheme()

  const isInactiveSparta = (vehicle) => {
    let invalid = false
    if (
      vehicle.id &&
      vehicle.shadowPR &&
      vehicle.spartaDetail &&
      !vehicle.spartaDetail.offerActive
    )
      invalid = true
    return invalid
  }

  let estimates = useSelector((state) => state.estimates.estimates)
  let user = useSelector((state) => state.user)
  const { firstName, employer } = user
  let proposalState = useSelector((state) =>
    state.proposal && state.proposal.proposal ? state.proposal.proposal : null
  )
  estimates.sort((a, b) => new Date(b.updatedOn) - new Date(a.updatedOn))
  estimates.sort((a, b) => {
    let aInvalid
    let aIsProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == a.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    if (proposalState && proposalState.isValid && proposalState.quoteId) {
      aInvalid = a.id != proposalState.quoteId
    } else if (!a.isValid) {
      aInvalid = true
    } else {
      aInvalid = false
    }
    if (!aInvalid && isInactiveSparta(a.vehicle) && !aIsProposalAcceptedQuote)
      aInvalid = true

    let bInvalid
    let bIsProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == b.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    if (proposalState && proposalState.isValid && proposalState.quoteId) {
      bInvalid = b.id != proposalState.quoteId
    } else if (!b.isValid) {
      bInvalid = true
    } else {
      bInvalid = false
    }
    if (!bInvalid && isInactiveSparta(b.vehicle) && !bIsProposalAcceptedQuote)
      bInvalid = true

    return aInvalid === bInvalid && bInvalid ? 0 : bInvalid ? -1 : 1
  })

  const hasNonIntegralYearTerm = estimates.some((estimate) => {
    return estimate.leaseTerm % 12 !== 0
  })

  const estimateItems = estimates.map((estimate) => (
    <EstimateItemWrapper key={estimate.id}>
      <EstimateItem
        estimate={estimate}
        proposal={proposalState}
        applicationRole={applicationRoles.CUSTOMER}
        headerHeight={headerHeight}
        vehicleDescHeight={vehicleDescHeight}
        isConsultant={checkConsultant()}
        userEmployer={employer}
        isHidden={isHidden}
        hasNonIntegralYearTerm={hasNonIntegralYearTerm}
      ></EstimateItem>
    </EstimateItemWrapper>
  ))
  const windowSize = useWindowSize()
  const size = windowSize.width
  const controlShow = () => {
    if (estimateItems && estimateItems.length === 1 && size > 0) {
      return false
    } else if (estimateItems && estimateItems.length === 2 && size > 768) {
      return false
    } else if (estimateItems && estimateItems.length === 3 && size > 1200) {
      return false
    } else {
      return true
    }
  }
  const resolutionBreakpoint = {
    nonDesktop: getCurrentResolutionBreakPoint(false),
  }
  let isMobile = size < resolutionBreakpoint.nonDesktop

  let [currentLimit, setCurrentLimit] = React.useState(estimates.length)
  const updateCurrentLimit = (showAll) => {
    if (!showAll) {
      setCurrentLimit((currentLimit = estimateItems.length - count))
    } else {
      setCurrentLimit((currentLimit = estimateItems.length))
    }
  }
  let count = 0
  if (estimates.length > 0 && currentLimit == 0) {
    updateCurrentLimit(true)
  }
  estimates.map((estimate) => {
    let invalid

    let isProposalAcceptedQuote =
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId &&
      proposalState.quoteId == estimate.id &&
      ((proposalState.acceptedOn != null &&
        proposalState.cancelledOn == null) ||
        (proposalState.acceptedOn != null &&
          proposalState.cancelledOn != null &&
          proposalState.acceptedOn > proposalState.cancelledOn))

    if (
      proposalState &&
      proposalState.isValid === false &&
      proposalState.quoteId == estimate.id
    ) {
      // Marks the estimate as inactive if proposal is invalid
      invalid = true
    } else if (
      proposalState &&
      proposalState.isValid &&
      proposalState.quoteId
    ) {
      invalid = estimate.id != proposalState.quoteId
    } else if (!estimate.isValid) {
      invalid = true
    } else {
      invalid = false
    }
    if (
      !invalid &&
      isInactiveSparta(estimate.vehicle) &&
      !isProposalAcceptedQuote
    )
      invalid = true

    if (invalid) {
      count++
    }
  })
  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest
    return (
      // remember to give it position:absolute
      <Container>
        <E.ListContainer>
          {count > 0 ? (
            <E.HideBox
              onClick={() => {
                toggleHide()
                goToSlide(0)
              }}
            >
              <CheckBoxStyled active={isHidden} />
              <div>&nbsp;Hide Inactive ({count})</div>
            </E.HideBox>
          ) : (
            <div></div>
          )}

          <E.CarousalNav>
            <E.NavCount>
              {' '}
              {size > 768
                ? estimates.length > 1
                  ? `Showing ${currentSlide + 1} - ${
                      currentSlide + 3 >= estimates.length
                        ? estimates.length
                        : currentSlide + 3
                    } of 
            ${estimates.length}`
                  : `Showing ${currentSlide + 1} of ${estimates.length}`
                : `${currentSlide + 1} of  ${estimates.length}`}
            </E.NavCount>
            <E.NavButton
              onClick={() => previous()}
              disabled={currentSlide == 0}
            >
              {' '}
              <LeftArrow />
            </E.NavButton>
            <E.NavButton
              onClick={() => next()}
              disabled={
                size > 768
                  ? currentSlide + 3 >= currentLimit
                  : currentSlide >= currentLimit - 1
              }
            >
              {' '}
              <RightArrow />
            </E.NavButton>
          </E.CarousalNav>
        </E.ListContainer>
      </Container>
    )
  }

  const isRelease = false
  {
    /*uncomment the below line when release is enabled*/
  }
  {
    /*useSelector(
    (state) =>
      state.opportunity.channel &&
      state.opportunity.channel.toLowerCase() == 'release'
  )*/
  }
  const registrationNumber = useSelector(
    (state) => state.opportunity.registrationNumber
  )
  const leaseEndDate = useSelector((state) => state.opportunity.leaseEndDate)
  const currentNLOutOfPocket = useSelector(
    (state) => state.opportunity.currentNLOutOfPocketCostPerPay
  )

  const bannerText = isRelease
    ? ' Have a look at your end of lease options below, compare with your current expiring lease, '
    : ' Compare an overview of your options below, '

  let endDate
  if (leaseEndDate && new Date(leaseEndDate) > new Date())
    endDate = remainingLeaseTime(leaseEndDate)

  let tooltip = (
    <span>
      {' '}
      <Tooltip
        header="Fortnightly out of pocket"
        text="The amount your current lease takes out of your take-home pay."
      />
    </span>
  )
  let releaseIcon = <img src="/images/benefit-car-icon.svg" />

  const [showReleasePopup, setShowReleasePopup] = useState(false)
  const toggleViewReleasePopup = () => {
    setShowReleasePopup(!showReleasePopup)
  }

  return (
    <Layout>
      <EstimateComparePageStyled>
        <div id="page" className="compare-estimate-page">
          <Modal
            show={showReleasePopup}
            onHide={toggleViewReleasePopup}
            size="xl"
          >
            <Modal.Header
              closeButton
              style={{
                background: 'transparent',
                borderBottom: 'none',
                paddingBottom: 0,
              }}
            ></Modal.Header>
            <Modal.Body>
              <div>
                <ReleasePopup />
              </div>
            </Modal.Body>
          </Modal>

          <div>
            <BannerMainImageSection>
              {isRelease && !isMobile && (
                <ReleaseBannerDesktopDiv>
                  <ReleaseCard
                    formattedOutOfPocket={formatCurrency(currentNLOutOfPocket)}
                    registrationNumber={registrationNumber}
                    remainingTime={endDate}
                    tooltip={tooltip}
                    icon={releaseIcon}
                    theme={theme}
                  />
                </ReleaseBannerDesktopDiv>
              )}
              <div>
                <h1 className="text-left mb-3" style={{color:'#fff'}}>Your Oly estimate is here</h1>
                <p className="mt-2 text-left">
                  Oly’s crunched the numbers and found you a perfect car (or cars), ready to get into with a novated lease. 
                  </p><p className="mt-2 text-left">
Hit the ‘View details’ button to take a closer look at each ride and for all the info on the lease. 
</p><p className="mt-2 text-left">
Want to make any changes? Get in touch!

                </p>
              </div>
            </BannerMainImageSection>
          </div>
          {isRelease && isMobile && (
            <ReleaseBannerMobileDiv>
              <ReleaseCard
                formattedOutOfPocket={formatCurrency(currentNLOutOfPocket)}
                registrationNumber={registrationNumber}
                remainingTime={endDate}
                tooltip={tooltip}
                icon={releaseIcon}
                theme={theme}
              />
            </ReleaseBannerMobileDiv>
          )}

          {isRelease && (
            <ReleaseBanner
              firstName={firstName}
              buttonClick={toggleViewReleasePopup}
              isMobile={isMobile}
            />
          )}
          <Container>
            <EstimateCompareIntro className="mt-3 mb-3">
              All estimates presented are for illustrative purposes only and are
              only current as at the date generated. Estimates shown may not be
              valid after the generation date.
            </EstimateCompareIntro>
          </Container>
          {estimateItems && estimateItems.length === 0 && (
            <Container>
              <div className="mt-5 mb-5 d-flex justify-content-center">
                <img src="/images/loader.gif" alt="" />
              </div>
            </Container>
          )}
          <div
            className={
              estimateItems && estimateItems.length === 3
                ? 'navigators estimate-list'
                : 'estimate-list'
            }
          >
            <Carousel
              arrows={false}
              renderButtonGroupOutside={true}
              customButtonGroup={<ButtonGroup />}
              additionalTransfrom={0}
              autoPlaySpeed={3000}
              centerMode={false}
              className=""
              containerClass="container"
              dotListClass=""
              draggable={controlShow()}
              swipeable={controlShow()}
              focusOnSelect={false}
              infinite={false}
              itemClass=""
              keyBoardControl
              renderDotsOutside={false}
              responsive={{
                desktop: {
                  breakpoint: {
                    max: 3000,
                    min: 1201,
                  },
                  items: 3,
                  partialVisibilityGutter: 0,
                },
                mobile: {
                  breakpoint: {
                    max: 768,
                    min: 0,
                  },
                  items: 1,
                  partialVisibilityGutter: 0,
                },
                tablet: {
                  breakpoint: {
                    max: 1200,
                    min: 769,
                  },
                  items: 2,
                  partialVisibilityGutter: 0,
                },
              }}
              showDots={false}
              sliderClass=""
              slidesToSlide={1}
            >
              {estimateItems}
            </Carousel>
          </div>
        </div>
      </EstimateComparePageStyled>
    </Layout>
  )
}

function mapStateToProps(state, ownProps) {
  const payFrequency = state.user && state.user.employer && state.user.employer.payFrequency
  const applicationRole = state.applicationRoles
  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = state.authentication.opportunityId
  const accessToken = state.auth.accessToken
  const estimatesExist = state.estimates.estimates.length !== 0

  return {
    isAuthenticated,
    opportunityId,
    payFrequency,
    applicationRole,
    accessToken,
    estimatesExist,
  }
}

export default connect(mapStateToProps)(withLocation(EstimatesScreen))
